import { useProductContext } from '../product-router';
import { useGenericFilters } from './filter-context';
import { SITE_FILTER_TYPE_NAME, DEFAULT_OPTION } from './filter-types';

export const useCurrentProductHasFilters = () => {
	const { getActiveProduct } = useProductContext();
	const product = getActiveProduct();
	const { filterDefinitions } = useGenericFilters();

	return !!(product && filterDefinitions[product.id]?.length > 0);
};

export const useGetCurrentProductFilters = () => {
	const { getActiveProduct } = useProductContext();
	const product = getActiveProduct();
	const { filterDefinitions } = useGenericFilters();

	return (product && filterDefinitions[product.id]) || [];
};

export const useCurrentProductHasAppliedFilters = () => {
	const filters = useGetCurrentProductFilters();
	let hasFilters = false;
	filters.forEach((filter) => {
		filter.store.availableFilters.forEach((option) => {
			if (option.isChecked && option.id !== DEFAULT_OPTION) {
				hasFilters = true;
			}
		});
	});
	return hasFilters;
};

export const useCurrentProductGenericSelectedFilterCount = () => {
	const filters = useGetCurrentProductFilters();
	const genericFilters = filters.filter((filter) => filter['@type'] !== SITE_FILTER_TYPE_NAME);
	return genericFilters.reduce(
		(filterCount, nextFilter) =>
			nextFilter.store.availableFilters.filter((f) => f.isChecked).length + filterCount,
		0,
	);
};
